module.exports = __webpack_public_path__ + "static/media/comp-cancel.3b8a4fd9.svg";